import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { QuoteCardPreview } from "./QuoteCardPreview";
import { matchesQuoteStatus } from "@/utils/quoteHelpers";
import styles from "./CancelQuoteDialog.module.css";
const WarningIcon = () => (_jsx("span", { className: "material-symbols-outlined", style: {
        color: "#F25B22",
        fontSize: "48px",
        fontVariationSettings: "'FILL' 1",
    }, children: "warning" }));
export const CancelQuoteDialog = ({ isOpen, quote, quoteIndex, onConfirm, onCancel, }) => {
    const confirmButtonRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            // Auto-focus on confirm button
            setTimeout(() => {
                confirmButtonRef.current?.focus();
            }, 100);
        }
        else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape" && isOpen) {
                onCancel();
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            return () => document.removeEventListener("keydown", handleEscape);
        }
    }, [isOpen, onCancel]);
    if (!isOpen)
        return null;
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };
    return (_jsx("div", { className: styles.overlay, onClick: handleOverlayClick, children: _jsxs("div", { className: styles.dialog, onClick: (e) => e.stopPropagation(), children: [_jsx("div", { className: styles.iconContainer, children: _jsx(WarningIcon, {}) }), _jsx("h3", { className: styles.title, children: "Cancel Quote Request" }), _jsxs("div", { className: styles.message, children: ["Are you sure you want to cancel this quote request?", _jsx("br", {}), _jsx("i", { children: "You can't undo this action." })] }), _jsx("div", { className: styles.quoteCardContainer, children: _jsx(QuoteCardPreview, { quote: quote, index: matchesQuoteStatus(quote.status, "draft") ||
                            matchesQuoteStatus(quote.status, "cancelled")
                            ? quoteIndex
                            : undefined }) }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { type: "button", className: styles.cancelButton, onClick: onCancel, children: "No, cancel" }), _jsx("button", { type: "button", className: styles.confirmButton, onClick: onConfirm, ref: confirmButtonRef, autoFocus: true, children: "Yes, I am sure" })] })] }) }));
};
